import api from "../api"
export default {
	/**
	 * Gets a list of notifications
	 * @param {number} offset
	 * @param {number} limit
	 */
	async getEmissionsForm() {
		let value = await api.get(`/emissionforms/2021`)
		if (!value || !value.data || !value.data.error || !value.data.data) {
			throw new Error("Could not get response!")
		}
		if (value.data.error.length > 0) {
			let error = new Error(value.data.error[0].message)
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
		let data = value.data.data
		return data
	},
	/**
	 *
	 * @param {number} requestID
	 * @param {Object[]} answers
	 */
	async submitForm(emissionID, answers) {
		let value = await api.post(`/emissionassessments`, {
			answers: answers,
			emissionID: emissionID,
		})
		//TODO FIX - return submission ID?

		if (!value.data || !value.data.error || !value.data.data) {
			throw new Error("Could not get response!")
		}
		if (value.data.error.length > 0) {
			let error = new Error(value.data.error[0].message)
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
		return value.data.data[0]
	},
	/**
	 *
	 * @param {number} emissionID
	 */
	async getResult(emissionID) {
		let value = await api.get(`/emissionassessments/${emissionID}`)

		if (!value.data || !value.data.error || !value.data.data) {
			throw new Error("Could not get response!")
		}
		if (value.data.error.length > 0) {
			let error = new Error(value.data.error[0].message)
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
		return value.data.data[0]
	},
	async getsuppliersemission() {
		let value = await api.get(`/suppliersemission`)
		if (value?.data?.error?.length > 0) {
			let error = new Error(value.data.error[0].message)
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}

		let data = value.data.data
		return data
	},
	async downloadEmissionsPDF(emissionID, score) {
		let value = await api.get(`/emissionforms/${emissionID}/pdf`, {
			params: {
				score: score
			},
			responseType: "blob",
			headers: {
				"Content-Type": "application/json",
				Accept: "application/pdf",
			},
		})

		if (value?.data?.error?.length > 0) {
			let error = new Error(value.data.error[0].message)
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}

		const url = window.URL.createObjectURL(new Blob([value.data]))
		const link = document.createElement("a")
		link.href = url
		link.setAttribute("target", "_blank")
		link.setAttribute("download", `Emissions_${emissionID}.pdf`)
		document.body.appendChild(link)
		link.click()
		document.body.removeChild(link)
	},
}
